"use strict";

define('evisions/dpobject',['evisions/dynamicproperty', 'underscore', 'evisions/helper'], function (EVIDynamicProperty, _, helper) {
  var DPMixin = {
    setup: function setup(proto) {
      var set = proto.set,
        get = proto.get;
      proto.set = function (key, value, options) {
        options = options || {};
        if (this[key] instanceof EVIDynamicProperty) {
          this.stopListening(this[key]);
          options.trigger = false;
        }
        var ret = set.apply(this, arguments);
        var value = this[key],
          that = this;
        if (value instanceof EVIDynamicProperty) {
          this.listenTo(value, 'change:Value', function () {
            that.trigger('change:' + key);
            that.trigger('change');
          });
        }
        return ret;
      };
      proto.get = function () {
        var value = get.apply(this, arguments);
        if (value instanceof EVIDynamicProperty) {
          return value.getValue();
        }
        return value;
      };
      return proto;
    }
  };
  return DPMixin;
});

